import { action, computed, makeObservable, observable } from 'mobx';
import { CensusModuleDependencies, ICensusModule } from './iCensusModule';

export interface CensusUploadDomainParams {
  groupId: string;
  enrollmentPeriodId: string;
}

export default abstract class ICensusUploadPageStore<
  DomainParams extends CensusUploadDomainParams,
  CensusModule extends ICensusModule<CensusModuleDependencies>,
> {
  protected abstract _censusModule: CensusModule;
  protected abstract _domainData: DomainParams;

  abstract getCensusData(): Promise<void>;
  abstract onCompleteRedirect(): void;

  protected _isLoading: boolean = false;

  public get isLoading(): boolean {
    return this._isLoading;
  }

  public get domainData(): DomainParams {
    return this._domainData;
  }

  public get censusModule(): CensusModule {
    return this._censusModule;
  }

  public setIsLoading(isLoading: boolean): void {
    this._isLoading = isLoading;
  }

  public async completeCensusUpload(): Promise<void> {
    await this._censusModule.uploadCensus();
    this.onCompleteRedirect();
  }

  constructor() {
    makeObservable<ICensusUploadPageStore<DomainParams, CensusModule>, '_isLoading'>(this, {
      _isLoading: observable,

      domainData: computed,
      censusModule: computed,
      isLoading: computed,

      setIsLoading: action.bound,
      completeCensusUpload: action.bound,
    });
  }
}
